'use strict'; // In case we're not running in the browser

var win = typeof window !== 'undefined' ? window : {};

var raf = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (
/* function */
callback) {
  return setTimeout(callback, 1000 / 60);
};

var caf = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || clearTimeout;
module.exports = {
  /**
   *
   * @param {function()} callback
   * @returns {number}
   */
  request: function request(callback) {
    return raf.call(win, callback);
  },

  /**
   * @param {number} id
   */
  cancel: function cancel(id) {
    return caf.call(win, id);
  }
};
//# sourceMappingURL=animationFrame.js.map